import is_project_tab_section from "./IsProjectTabSection"
import is_remote_data_table_source from "../../../mixins/IsRemoteDataTableSource"

const is_project_data_source_tab_section = {
    mixins: [is_project_tab_section, is_remote_data_table_source],
    mounted () {
        this.reroot()
    },
    watch: {
        "record.id": "reroot"
    },
    methods: {
        refresh () {
            if(!this.entity) console.error("IsRemoteDataTableSource has no entity defined.")

            if(!!this.state.project_id && (this.is_public_page || this.profile_id)) {
                const query = {
                    ...this.state,
                    fields: this.fields,
                    relation_ids: this.relation_ids
                }

                this.loading = true
                this.$store.dispatch(
                    "FETCH_RECORDS",
                    {
                        entity: this.entity,
                        query
                    }
                ).then(response => {
                    this.current_records_ids = response.record_ids

                    this.set_state_values({
                        total: response.total || 0,
                        found: response.found || 0,
                        query_info: response.query_info || {}
                    })

                    this.post_load(response)
                }).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.loading = false
                })
            }
        },
        reroot () {
            this.set_state_value("project_id", this.record ? this.record.id : 0)
            this.reset()
        },
        save_for_record_id (record_id, value, field) {
            this.save_field_for_record_id(this.entity, record_id, value, field)
        },
        create_record () {
            if(!this.editable) return
            this.$store.dispatch("CREATE_RECORD", {
                entity: this.entity,
                data: { project_id: this.record.id }
            }).then(record => {
                this.current_records_ids.push(record.id)
                this.set_state_values({
                    total: this.state.total + 1,
                    found: this.state.found + 1 || 0
                })
            }).catch(error => {
                this.$error(error.message)
            })
        },
        delete_record (record) {
            if(!this.editable) return
            this.$store.dispatch("RECORD_DELETE", {
                entity: this.entity,
                id: record.id
            }).then(() => {
                const index = this.current_records_ids.indexOf(record.id)
                if(index >= 0) {
                    this.current_records_ids.splice(index, 1)
                    this.set_state_values({
                        total: this.state.total - 1,
                        found: this.state.found - 1 || 0
                    })
                }
            }).catch(error => {
                this.$error(error.message)
            })
        }
    },
    computed: {
        visible_columns () {
            const { project_id, ...visible_columns } = this.columns
            return visible_columns
        },
        rows () {
            if(!this.state.project_id) return []
            return this.$store.getters.entity_records(this.entity, this.current_records_ids).filter(row => row.project_id === this.state.project_id)
        }
    },
    data () {
        return {
            default_state: {
                per_page: 0,
                page: 1,
                sort_by: null,
                sort_dir: null,
                filter_on: "project_id",
                filter: null,
                archived: false,
                search: "",
                total: 0,
                found: 0,
                query_info: {},
                project_id: 0
            }
        }
    }
}

export default is_project_data_source_tab_section
